export default __webpack_public_path__ + "static/iconography-image-j-bdb782c497e36a49c9e3ac627e7cb9df.png";